import styled from "@emotion/styled";
import { Button, Typography } from "@mui/material";

const ListPropertyBtn = styled(Button)(({ theme }) => ({
  border: "1px red solid",
  color: "red",
}));

const HeaderItems = styled(Typography)(({ theme, isActive }) => ({
  textDecoration: isActive ? "underline" : "none",
  color: isActive ? "red" : "black",
  textUnderlineOffset: isActive ? "8px" : "0px",
  fontWeight: "500",
  textTransform: "uppercase",
  "&:hover": {
    color: "red", 
  },
}));

const OffplanItem = styled(Typography)(({ theme }) => ({
  display: "block",
  padding: "10px 20px",
  textDecoration: "none",
  color: "black",
}));

const ResponsiveLogo = styled('img')({
  maxWidth: '150px',
  height: 'auto',
  transition: 'transform 0.2s',
  '@media (max-width: 900px)': {
    maxWidth: '80px'
  },
  '&:hover': {
    transform: 'scale(1.05)'
  }
});

const NavLink = styled(Typography)(() => ({
  color: 'inherit',
  textDecoration: 'none',
  textTransform: 'capitalize',
  fontWeight: 300,
  padding: '10px 15px',
  position: 'relative',
  display: 'inline-block',
  transition: 'color 0.3s ease',
  '&::after': {
    content: '""',
    position: 'absolute',
    width: '0',
    height: '2px',
    bottom: '0',
    left: '0',
    backgroundColor: '#C10E14',
    transition: 'width 0.3s ease'
  },
  '&:hover::after': {
    width: '100%'
  },
  '&:hover': {
    color: '#C10E14'
  }
}));

const PropertyListButton = styled(Button)(() => ({
  borderRadius: '24px',
  textTransform: 'lowercase',
  fontWeight: 600,
  padding: '10px 20px',
  borderColor: '#C10E14',
  color: '#C10E14',
  '&:hover': {
    backgroundColor: 'rgba(255,0,0,0.1)'
  }
}));

export { ListPropertyBtn, HeaderItems, OffplanItem, ResponsiveLogo, NavLink, PropertyListButton };
